import aButton from '../../assets/museu/a.png';
import arrowButton from '../../assets/museu/arrow.png';
import './navigation.css';
import { useArrowNavigation } from '../../hooks/useArrowNavigation';
import { canMoveDown, canMoveLeft, canMoveRight, canMoveUp, isFacingCarinha, isNextToCarinha } from '../../utils/Movement';
import { useKeyPressedOnce } from '../../hooks/useKeyPressedOnce';
import { Coordinate, Move } from '../../model';

interface NavigationButtonsProps {
  onUp(): void;
  onDown(): void;
  onRight(): void;
  onLeft(): void;
  onSee(): void;
  coord: Coordinate;
  dir: Move;
}

const NavigationButtons: React.VFC<NavigationButtonsProps> = ({ onUp, onDown, onRight, onLeft, onSee, coord, dir }) => {
  const facesCarinha = isNextToCarinha(coord);
  
  useArrowNavigation({
    onUp,
    onDown,
    onRight,
    onLeft,
  });

  useKeyPressedOnce('a', onSee);
  useKeyPressedOnce('A', onSee);

  return (
    <>
      <section className="move-buttons">
        <button className="arrow-button up" onClick={onUp} disabled={!canMoveUp(coord, dir) && !facesCarinha}>
          <img alt='up' src={arrowButton} />
        </button>
        <div>
          <button className="arrow-button left" onClick={onLeft} disabled={!canMoveLeft(coord, dir)}>
            <img alt='left' src={arrowButton} />
          </button>
          <button className="arrow-button down" onClick={onDown} disabled={!canMoveDown(coord, dir)}>
            <img alt='down' src={arrowButton} />
          </button>
          <button className="arrow-button right" onClick={onRight} disabled={!canMoveRight(coord, dir) && !facesCarinha}>
            <img alt='right' src={arrowButton} />
          </button>
        </div>
      </section>

      <button className="see-button" disabled={!isFacingCarinha(dir, coord)} onClick={onSee}>
        <img alt='see' src={aButton} />
      </button>
    </>
  );
}

export default NavigationButtons;
